import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
};

const violationsEntitlementSlice = createSlice({
  name: 'aag/violationsEntitlement',
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
});

const { reducer: violationsEntitlementReducer, actions } =
  violationsEntitlementSlice;

export const violationsEntitlementActions = actions;
export default violationsEntitlementReducer;
